"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteTemplate = void 0;
exports.RouteTemplate = {
    Cart: {
        addToCart: '/checkout/cart/{*}/add',
        removeFromCart: '/checkout/cart/{*}/remove',
        updateCart: '/checkout/cart/{*}/update',
        indexCart: '/checkout/cart',
    }
};
